import React from 'react';

export default function FwChannelIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-sitemap' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
